import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { CartProvider } from "@/context/CartContext";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import TickerBar from "@/components/TickerBar";
import About from "@/components/About";
import Products from "@/components/Products";
import Process from "@/components/Process";
import SourcingMap from "@/components/SourcingMap";
import WhyChooseUs from "@/components/WhyChooseUs";
import Applications from "@/components/Applications";
import Testimonials from "@/components/Testimonials";
import Certifications from "@/components/Certifications";
import BulkInquiry from "@/components/BulkInquiry";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import CartDrawer from "@/components/CartDrawer";
import WhatsAppFloat from "@/components/WhatsAppFloat";
import ProductDetail from "@/pages/ProductDetail";
import AdminDashboard from "@/pages/AdminDashboard";

const Home = () => (
    <>
        <Navbar />
        <main>
            <Hero />
            <TickerBar />
            <Products />
            <About />
            <SourcingMap />
            <Process />
            <WhyChooseUs />
            <Applications />
            <Testimonials />
            <Certifications />
            <BulkInquiry />
            <Contact />
        </main>
        <Footer />
        <CartDrawer />
        <WhatsAppFloat />
    </>
);

function App() {
    return (
        <div className="App">
            <CartProvider>
                <BrowserRouter>
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/product/:id" element={<ProductDetail />} />
                        <Route path="/admin" element={<AdminDashboard />} />
                    </Routes>
                </BrowserRouter>
                <Toaster position="bottom-left" />
            </CartProvider>
        </div>
    );
}

export default App;
